<template>
  <table id="tableHead" class="table-head table-head-weather">
    <tr>
      <td class="time" rowspan="2">時間</td>
      <td colspan="2">平均</td>
      <td colspan="2">最大瞬間</td>
      <td>気温</td>
      <td>湿度</td>
      <td>現地気圧</td>
      <td colspan="3">雨量</td>
      <td>降雨強度</td>
    </tr>
    <tr>
      <td>風速<br />(m/s)</td>
      <td>風向</td>
      <td>風速<br />(m/s)</td>
      <td>風向</td>
      <td>(℃)</td>
      <td>(%)</td>
      <td>(hPa)</td>
      <td>10分雨量<br />(mm)</td>
      <td>時間積算<br />(mm)</td>
      <td>日積算<br />(mm)</td>
      <td>(mm/h)</td>
    </tr>
  </table>
</template>

<style scoped lang="sass">
.table-head
  width: 1731px
</style>
